const getFileChunk = (file, chunkIndex, chunkSize) => {
  const start = chunkIndex * chunkSize;
  const end = Math.min(start + chunkSize, file.size);
  const blob = file.slice(start, end);
  return new Blob([
    blob
  ], {
    type: file.type
  });
};

export { getFileChunk };
//# sourceMappingURL=getFileChunk.js.map
